import { j as e } from "./atoms-v218.js";
import { forwardRef as _, useContext as q, useCallback as C, useState as $ } from "react";
import b from "./atoms-v2122.js";
import { InputContainer as A } from "./atoms-v2114.js";
import { InputHelper as o } from "./atoms-v220.js";
import { InputOutline as J } from "./atoms-v223.js";
import { TextareaSkeleton as P } from "./atoms-v2742.js";
import { FormGroupContext as Q } from "./atoms-v2130.js";
import { useMergedRefs as W } from "./atoms-v2712.js";
import { Textarea as X, Footer as Y, MaxLength as Z } from "./atoms-v2743.js";
const z = _(
  ({
    autoSize: i = !1,
    className: y = "",
    colorTheme: r = "light",
    defaultValue: g = "",
    disabled: h = !1,
    error: n,
    helperText: a,
    id: E,
    isSkeleton: G = !1,
    label: M,
    maxLength: t,
    maxRows: R,
    minRows: V = 1,
    name: u,
    onBlur: l,
    onFocus: c,
    onHeightChange: k,
    readOnly: f = !1,
    variant: d = "productive",
    ...v
  }, K) => {
    const { isGroupedInput: p } = q(Q), m = C(
      (s) => s ? t ? s.substring(0, t) : s : "",
      [t]
    ), [O, I] = $(m(g)), [U, F] = $(!1), w = C(
      (s) => {
        const S = b(s, "value", "");
        I(m(S));
      },
      [m]
    ), B = W([K, w]), D = (s) => {
      F(!1), l && typeof l == "function" && l(s);
    }, H = (s) => {
      F(!0), c && typeof c == "function" && c(s);
    }, N = (s) => {
      I(b(s, "target.value", ""));
    };
    if (G)
      return /* @__PURE__ */ e.jsx(P, { helperText: a });
    const x = !!n, j = `${u}_errormessage`;
    return /* @__PURE__ */ e.jsxs(A, { className: y, variant: d, children: [
      /* @__PURE__ */ e.jsxs(
        J,
        {
          colorTheme: r,
          isDisabled: h || f,
          isErrored: x,
          isFocused: U && !f,
          isGroupedInput: p,
          variant: d,
          children: [
            /* @__PURE__ */ e.jsx(
              X,
              {
                ...v,
                $autoSize: i,
                $variant: d,
                "aria-invalid": x,
                defaultValue: g,
                disabled: h,
                id: E || u,
                maxLength: t,
                name: u,
                onBlur: D,
                onFocus: H,
                onKeyUp: N,
                placeholder: M,
                readOnly: f,
                ref: B,
                ...!i && { as: "textarea" },
                ...i && {
                  cacheMeasurements: !0,
                  maxRows: R,
                  minRows: V,
                  onHeightChange: k
                },
                $colorTheme: r,
                ...x && { "aria-describedby": j }
              }
            ),
            p ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx(o, { isGroupedInput: !0, colorTheme: r, children: !n && a }),
              /* @__PURE__ */ e.jsx(o, { isError: !0, isGroupedInput: !0, colorTheme: r, id: j, children: n })
            ] }) : null
          ]
        }
      ),
      /* @__PURE__ */ e.jsxs(Y, { children: [
        p ? null : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(o, { colorTheme: r, children: !n && a }),
          /* @__PURE__ */ e.jsx(o, { isError: !0, colorTheme: r, id: j, children: n })
        ] }),
        t ? /* @__PURE__ */ e.jsxs(Z, { children: [
          O.length,
          "/",
          t
        ] }) : null
      ] })
    ] });
  }
);
z.displayName = "Textarea";
export {
  z as Textarea
};
